import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface DialogData {
  name: string;
  rename: boolean;
}
@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {

  myGroup: UntypedFormGroup;

  constructor(public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit() {
    this.myGroup = new UntypedFormGroup({
      name: new UntypedFormControl(this.data.name)
    });
    this.myGroup.controls['name'].setValidators([Validators.required]);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  checkName(control: UntypedFormControl) {
    if (control.value !== null) {
      return null;
    } else {
      return { err: true };
    }
  }

}
